const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Wallet Account No.',
        dataIndex: 'walletAccountNo',
        sorter: true,
    },
    {
        title: 'Wallet Balance',
        dataIndex: 'balance',
        sorter: true,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        sorter: true,
    },
    {
        title: 'Withdraw Type',
        dataIndex: 'withdrawType',
        sorter: true,
    },
    {
        title: 'Request Date',
        dataIndex: 'requestDate',
        sorter: true,
    },
    {
        title: 'Declined Date',
        dataIndex: 'actionDate',
        sorter: true,
    },
    {
        title: 'Action By',
        dataIndex: 'actionBy',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }

];

export default columns;